import 'whatwg-fetch';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

import {
  iterUnpack,
  defaultLogoImageUrl,
  defaultUserAvatarUrl,
} from '../../services/APIClient';
import SegmentClient from '../../services/SegmentClient';
import {
  ANALYTICS_NAME,
  BASE_URL,
  CONTACT_MODAL_HASH,
} from './Constants';
import { UserResource, BrandResource } from '../../services/RESTClient';
import RequireRegisterPopup, { PERMISSION_TYPES } from '../RequireRegisterPopup';

const segment = new SegmentClient();
const userResource = new UserResource();
Modal.setAppElement('#root');

export default class BrandContactModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brand: {
        slug: '',
        logoUrl: '',
        djangoId: '',
        name: '',
        brandTier: {},
        avatars: [],
        numRepresentatives: 0,
      },
      contact: {
        name: '',
        email: '',
        requestType: '',
        message: '',
      },
      validation: {
        required: {
          name: true,
          email: true,
          requestType: true,
          message: true,
        },
        formatting: {
          email: true,
        },
      },
      failure: false,
      sending: false,
      user: null,
      openRequireRegister: false,
      requireRegisterNext: null,
    };

    this.canContact = false;
    this.isLoadingUser = false;

    this.errorMessageTimeout = 4000;
  }

  UNSAFE_componentWillMount() {
    const props = iterUnpack(JSON.parse(window.props));
    const {
      slug,
      people,
      logo,
      djangoId,
      brandTier,
      name,
    } = props.allBrands[0];
    /* TODO user `mediatype` param on this field in GraphQL instead of this: */
    const avatars = people.reduce((accumulator, { id, user }) => {
      const mediaArray = user.avatar;
      const logoObj = mediaArray[0];
      const url = logoObj ? logoObj.mediaItem.thumbnail : defaultUserAvatarUrl;
      accumulator.push({
        id,
        url,
      });
      return accumulator;
    }, []);
    const brandLogoUrl = logo.length ? logo[0].mediaItem.thumbnail : defaultLogoImageUrl;
    const brandState = Object.assign({}, this.state.brand, {
      avatars: avatars.slice(0, 6),
      numRepresentatives: avatars.length,
      logoUrl: brandLogoUrl,
      djangoId,
      isPremium: BrandResource.isPremium(brandTier),
      name,
      slug,
    });

    this.setState({
      brand: brandState,
    });
  }

  componentDidMount() {
    this.isLoadingUser = true;

    window.onload = () => {
      userResource.me()
        .then(user => this.setState({ user: user.data }))
        .catch(() => {})
        .finally(() => {
          this.isLoadingUser = false;
          this.canContact = userResource.canContactBrand();

          if (this.canContact) {
            if (window.location.hash === CONTACT_MODAL_HASH) {
              this.handleSendMessageClick();
            }
          } else if (window.location.hash === CONTACT_MODAL_HASH) {
            this.setState(({ openRequireRegister: true }));
          }
        });
    };
  }

  handleSendMessageClick = (e) => {
    const { slug } = this.state.brand;
    if (e) {
      e.preventDefault();
    }

    if (this.canContact && slug) {
      const contact = () => {
        segment.track(ANALYTICS_NAME.BRAND_CONTACT_MODAL_OPENED);
        window.openBrandMessagePopup();
      };

      // Generic and Non Pro users don't have Intercom accounts per Intercom limitations,
      // thus, identify them on demand to create accounts for them
      if (userResource.isGeneric() || userResource.isNonProfessional()) {
        segment.identify({ force: true, callback: () => contact() });
      } else {
        contact();
      }
    } else if (!this.isLoadingUser) {
      this.setState({
        openRequireRegister: true,
        requireRegisterNext: `/${BASE_URL}/${slug}/${CONTACT_MODAL_HASH}`,
      });
    }
  }

  render() {
    return (
      <div>
        <a
          tabIndex="0"
          href={CONTACT_MODAL_HASH}
          role="button"
          className="button white fw-medium"
          onClick={this.handleSendMessageClick}
        >
          <>
            <span className="material-icons fs-s mr-s">chat_bubble</span>
            {' '}
            Send Message
          </>
        </a>

        {this.state.openRequireRegister && (
          <RequireRegisterPopup
            permissionType={PERMISSION_TYPES.CONTACT}
            permissionDestinationUrl={`${window.location.href}${CONTACT_MODAL_HASH}`}
            onClose={() => {
              this.setState({ openRequireRegister: false });
            }}
            nextParam={this.state.requireRegisterNext}
          />
        )}
      </div>
    );
  }
}

const root = document.getElementById('brand-contact-modal');
if (root) {
  ReactDOM.render(
    <BrandContactModal />,
    root,
  );
}
